// extracted by mini-css-extract-plugin
export default {"alerticon":"ErrorPage_alerticon__S2Ef9","errortext":"ErrorPage_errortext__xSCAF","errorinfo":"ErrorPage_errorinfo__AWFKX"};